<template>
    <div class="ui-import">
        <!-- 04.01.批量导入 - 头部 Start -->
        <div class="ui-title">
            <h3><i class="el-icon-edit"></i>01.模板信息</h3>
        </div>
        <!-- 04.01.批量导入 - 头部 End -->
        <!-- 04.02.批量导入 - 步骤 Start -->
        <div class="ui-steps">
            <el-steps :active="uploadSteps" simple>
                <el-step title="01.模板信息" icon="el-icon-edit"></el-step>
                <el-step title="02.导入信息" icon="el-icon-upload"></el-step>
                <el-step title="03.导入结果" icon="el-icon-picture"></el-step>
            </el-steps>
        </div>
        <!-- 04.02.批量导入 - 步骤 End -->
        <!-- 04.03.批量导入 - 内容 Start -->
        <div class="ui-content">
            <!-- 04.03.01.批量导入 - 模板信息 Start -->
            <div class="ui-template" v-show="uploadSteps===0">
                <img src="../../../public/images/upload.png">
                <div class="ui-template-right">
                    <div class="ui-template-right-link">
                        <span><i class="ion-md-cloud-download"></i>下载</span>
                        <el-link type="primary" :underline="false" :href="uploadHref">《 {{ aTitle }} 》</el-link>
                    </div>
                    <div class="ui-template-right-upload">
                        <el-upload ref="upload" :action="uploadAPI" :auto-upload="false" :show-file-list="false" :headers="{'token':this.token}" :on-progress="uploadProgress" :on-change="uploadChange" :on-success="uploadSuccess">
                            <div class="ui-file" v-if="uploadSelect">
                                <i class="el-icon-s-order"></i>
                                <p v-html="uploadTitle"></p>
                            </div>
                            <el-empty v-else description="仅支持 XLSX 格式的文件"></el-empty>
                        </el-upload>
                    </div>
                    <div class="ui-template-right-button" v-if="uploadSelect">
                        <el-button type="primary" plain :disabled="false" @click="getStepNext">确认导入<i class="el-icon-arrow-right el-icon--right"></i></el-button>
                    </div>
                </div>
            </div>
            <!-- 04.03.01.批量导入 - 模板信息 End -->
            <!-- 04.03.02.批量导入 - 导入信息 Start -->
            <div class="ui-upload" v-show="uploadSteps===1">
                <div class="ui-upload-left">
                    <ul>
                        <li><i class="el-icon-success"></i><span>导入成功：<span v-html="uploadState.success"></span></span>
                        </li>
                        <li><i class="el-icon-warning"></i><span>导入异常：<span v-html="uploadState.warning"></span></span>
                        </li>
                        <li><i class="el-icon-error"></i><span>导入失败：<span v-html="uploadState.error"></span></span></li>
                    </ul>
                    <el-button type="primary" plain :disabled="false" @click="getStepUpload" v-if="uploadSelect">确认上传<i class="el-icon-arrow-right el-icon--right"></i></el-button>
                    <el-button plain :disabled="false" @click="getStepAgain" v-else><i class="el-icon-arrow-left"></i>重新上传</el-button>
                </div>
                <div class="ui-upload-right">
                    <div class="ui-upload-right-progress">
                        <el-progress :text-inside="true" :stroke-width="28" :percentage="uploadState.progress" :color="progressColor"></el-progress>
                    </div>
                    <div class="ui-upload-right-textarea">
                        <el-input type="textarea" placeholder="上传过程反馈信息" v-model="uploadState.content" readonly></el-input>
                    </div>
                </div>
            </div>
            <!-- 04.03.02.批量导入 - 导入信息 End -->
            <!-- 04.03.03.批量导入 - 导入结果 Start -->
            <div class="ui-result ui-success" v-show="uploadSteps===2" v-if="uploadResult">
                <i class="el-icon-success"></i>
                <p>批量导入成功</p>
                <span>{{ aTitle }}数据成功导入系统</span>
                <el-button type="primary" plain :disabled="false" @click="getStepLog">上传日志</el-button>
                <el-button type="primary" plain :disabled="false" @click="getStepAgain">重新上传</el-button>
            </div>
            <div class="ui-result ui-error" v-show="uploadSteps===2" v-else>
                <i class="el-icon-error"></i>
                <p>批量导入失败</p>
                <span>{{ aTitle }}数据导入系统失败</span>
                <el-button type="primary" plain :disabled="false" @click="getStepLog">上传日志</el-button>
                <el-button type="primary" plain :disabled="false" @click="getStepAgain">重新上传</el-button>
            </div>
            <!-- 04.03.03.批量导入 - 导入结果 End -->
        </div>
        <!-- 04.03.批量导入 - 内容 End -->
    </div>
</template>

<script>
    export default {
        name: "upload",
        props: ['aTitle', 'aApi', 'aTemplate'],
        data() {
            return {
                // 01.基础数据 ------------------------------------------------
                // 01.01.Token
                token: localStorage.getItem('Token'),
                // 01.02.上传步骤
                uploadSteps: 0,
                // 01.03.上传结果
                uploadResult: true,
                // 01.04.上传模板URL
                uploadHref: this.$api_url + this.aTemplate,
                // 01.05.上传API接口
                uploadAPI: this.$api_url + this.aApi,
                // 01.06.导入状态
                uploadState: {
                    "content": "",
                    "progress": 0,
                    "success": 0,
                    "warning": 0,
                    "error": 0
                },
                // 01.07.导入进度条 - 颜色
                progressColor: [
                    {color: 'rgba(2, 145, 255, 0.6)', percentage: 20},
                    {color: 'rgba(2, 145, 255, 0.7)', percentage: 40},
                    {color: 'rgba(2, 145, 255, 0.8)', percentage: 60},
                    {color: 'rgba(2, 145, 255, 0.9)', percentage: 80},
                    {color: 'rgba(2, 145, 255, 1)', percentage: 99},
                    {color: '#7ed221', percentage: 100}
                ],
                // 01.08.上传进度定时状态
                uploadTimer: false,
                // 01.09.文件是否选中
                uploadSelect: false,
                // 01.10.待上传文件名
                uploadTitle: ""
            };
        },
        // 监听属性
        computed: {},
        // 监控data中的数据变化
        watch: {},
        // 方法集合
        methods: {
            // 01.步骤按钮
            // 01.01.确认导入
            getStepNext() {
                this.uploadSteps = 1
            },
            // 01.02.确认上传
            getStepUpload() {
                this.getUploadImport()
            },
            // 01.03.重新上传
            getStepAgain() {
                this.uploadSteps = 0
                this.uploadState.content = ""
                this.uploadAbort()
            },
            // 01.04.上传日志
            getStepLog() {
                this.uploadSteps = 1
                this.uploadAbort()
            },
            // 02.上传操作
            // 02.01.上传组件状态改变
            uploadChange(file) {
                if (file) {
                    if (file.raw.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
                        this.uploadTitle = file.name
                        this.uploadSelect = true
                    } else {
                        this.$message.error("批量导入的文件类型只能是 xlsx 格式")
                        this.uploadTitle = ''
                        this.uploadSelect = false
                    }
                } else {
                    this.uploadTitle = ''
                    this.uploadSelect = false
                }
            },
            // 02.02.清空上传列表
            uploadAbort() {
                this.$refs['upload'].clearFiles()
                this.uploadTitle = ''
                this.uploadSelect = false
            },
            // 02.03.上传并获取进度
            uploadProgress() {
                this.$api.post('/api/upload/progress/').then((response) => {
                    if (response.code === 200) {
                        this.uploadState.content = response.content
                        this.uploadState.progress = response.progress
                        this.uploadState.success = response.success
                        this.uploadState.warning = response.warning
                        this.uploadState.error = response.error
                        if (response.message === "进度更新完成") {
                            clearInterval(this.uploadTimer)
                        }
                    }
                }).catch(err => {
                    if (err) {
                        clearInterval(this.uploadTimer)
                    }
                })
            },
            // 02.04.上传完成
            uploadSuccess(response) {
                if (response.code === 200) {
                    window.setTimeout(() => {
                        this.uploadSteps = 2
                        this.uploadResult = true
                    }, 1000);
                } else {
                    window.setTimeout(() => {
                        this.uploadSteps = 2
                        this.uploadResult = false
                    }, 1000);
                }
            },
            // 02.05.上传确认导入
            getUploadImport() {
                // 开始将文件上传API接口
                this.$refs.upload.submit()
                // 每秒获取上传当前状态
                this.uploadTimer = window.setInterval(() => {
                    this.uploadProgress()
                }, 100)
            },
        },
        // 生命周期 - 创建之前
        beforeCreate() {
        },
        // 生命周期 - 创建完成
        created() {
        },
        // 生命周期 - 挂载之前
        beforeMount() {
        },
        // 生命周期 - 挂载完成
        mounted() {
        },
        // 生命周期 - 更新之前
        beforeUpdate() {
        },
        // 生命周期 - 更新之后
        updated() {
        },
    }
</script>
